<template>
  <div>
    <a-card class="margin-bottom">
      <a-form-model ref="formInput" :model="form" :rules="rules">
        <a-row :gutter="12">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item label="Termin Detail" prop="termin_release_dtl">
              <a-select
                v-model="form.termin_release_dtl"
              >
                <a-select-option
                  v-for="item in detil_termin_list"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.termin_description }} | {{ formatCurrency("IDR",item.value) }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="Product/Work" prop="produk_name">
              <a-input v-model="form.produk_name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="PN" prop="pn">
              <a-input v-model="form.pn"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Quantity" prop="qty" style="display:none">
              <a-input-number
                v-model="form.qty"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                disabled
              ></a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item label="Unit" prop="unit" style="display:none">
              <a-input v-model="form.unit"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Amount" prop="unit_price">
              <a-input-number
                v-model="form.unit_price"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Note" prop="note">
              <a-textarea v-model="form.note" :rows="5"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="action">
        <a-button-group>
          <a-button type="default" @click="handleDetail">{{
            isEdit.status ? "Submit Changes" : "Add Detail"
          }}</a-button>
          <a-button
            v-if="isEdit.status"
            type="primary"
            @click="handleCancel"
            icon="close"
          ></a-button>
        </a-button-group>
      </div>
    </a-card>
    <a-card title="Detail List">
      <span slot="extra">
        <h4 class="m-text-align right margin-remove">
          Grand Total :
          {{ formatCurrency(currency, sum_table) }}
        </h4>
      </span>
      <a-table
        :pagination="false"
        bordered
        :rowKey="(record, index) => {return index;}"
        :columns="columns"
        :data-source="sourcedata"
        :scroll="{ x: 1200 }"
      >
        <span slot="product_nm" slot-scope="item">
          <h4>{{item.product_nm}}</h4>
          {{ item.product_pn }}
        </span>
        <span slot="title_total_price"> Total Price ({{ currency }} ) </span>
        <span slot="termin_release_dtl" slot-scope="item">
          <h4>{{item.termin_release_dtl_nm}}</h4>
          {{ formatCurrency("IDR",item.termin_release_dtl_value) }}
        </span>
        <span slot="total_price" slot-scope="text">
          {{
            formatCurrency(
              text.currency,
              parseFloat(text.unit_price) * parseFloat(text.qty)
            )
          }}
        </span>
        <div slot="unitPrice">Amount ( {{ currency }} )</div>
        <span slot="upValue" slot-scope="item">
          {{ formatCurrency(item.currency, item.unit_price) }}
        </span>
        <a-button-group slot="action" slot-scope="item">
          <a-button
            @click="handleEdit(item)"
            type="primary"
            icon="edit"
            :disabled="isEdit.status"
          ></a-button>
          <a-button icon="close" 
          @click="handleRemove(item)"
          :disabled="isEdit.status"
          ></a-button>
        </a-button-group>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import nanoid from "nanoid";
import _ from "lodash";
export default {
  name: "Product-Detail",
  props: {
    detil_product: {},
    detil_termin_list: {},
    currency: String,
    mode: String,
  },
  mixins: [CurrencyFormat],
  data() {
    const columns = [
      {
        title: "Product/Work",
        scopedSlots: { customRender: "product_nm" },
        key: "product_nm",
        width: 200,
      },
      {
        title: "Termin Detail",
        key: "termin_release_dtl",
        scopedSlots: { customRender: "termin_release_dtl" },
        width: 200,
      },
      // {
      //   title: "PN",
      //   dataIndex: "product_pn",
      //   key: "product_pn",
      //   width: 200,
      // },
      // {
      //   title: "Unit",
      //   dataIndex: "unit",
      //   key: "unit",
      //   width: 100,
      // },
      {
        title: "Note",
        dataIndex: "note",
        key: "note",
        width: 200,
      },
      {
        key: "unit_price",
        align: "right",
        slots: { title: "unitPrice" },
        scopedSlots: { customRender: "upValue" },
        width: 200,
      },
      {
        title: "Action",
        width: 100,
        key: "action",
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];
    return {
      columns,
      form: {
        qty : 1
      },
      rules: {
        termin_release_dtl: {
          required: true,
          message: "Please input Termin Detail",
          trigger: "blur",
        },
        produk_name: {
          required: true,
          message: "Please input Product",
          trigger: "blur",
        },
        pn: {
          required: false,
          message: "Please input pn",
          trigger: "blur",
        },
        qty: {
          required: true,
          message: "Please input quantity",
          trigger: "blur",
        },
        unit: {
          required: false,
          message: "Please input unit",
          trigger: "blur",
        },
        unit_price: {
          required: true,
          message: "Please input amount",
          trigger: "blur",
        },
      },
      isEdit: {
        status: false,
        item: {},
      },
      sourcedata: [],
    };
  },
  mounted() {
    this.sourcedata = this.detil_product;
  },
  computed: {
    sum_table() {
      return this.sourcedata.reduce(
        (sum, item) => sum + parseInt(item.qty) * parseInt(item.unit_price),
        0
      );
    },
  },
  methods: {
    // onChange(key, value) {
    //   const source = [...this.getDetailProduct];
    //   const target = source.find((item) => item.pn == key.pn);
    //   if (target) {
    //     if (this.mode == "Create") {
    //       target.unitPrice = value;
    //     } else {
    //       target.unit_price = value;
    //     }
    //     this.$store.dispatch("setDetailProduct", source);
    //   }
    // },
    // handleRef() {
    //   if (this.isEdit.status) {
    //     this.displayMessageValue("basic-error", "Complete your changes!");
    //     return;
    //   }
    //   let isEmpty;
    //   isEmpty = this.getDetailProduct.filter(
    //     (item) =>
    //       parseFloat(item.unit_price <= 0) ||
    //       item.unit_price == null ||
    //       item.unit_price == 0
    //   );
    //   if (isEmpty.length > 0) {
    //     this.displayMessageValue(
    //       "basic-error",
    //       "Amount must be more than 0. Please check your detail!"
    //     );
    //     return;
    //   }
    //   Event.$emit("dataProcessed", this.getDetailProduct);
    // },
    handleDetail() {
      this.$refs.formInput.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.form.unit_price == 0) {
          this.displayMessageValue("error", "Amount must higher than 0");
          return;
        }
        if (this.form.qty == 0) {
          this.displayMessageValue("error", "Quantity must higher than 0");
          return;
        }

        let trd = _.filter(this.detil_termin_list, (obj) => obj.id === this.form.termin_release_dtl);

        const data = {
          currency: "IDR",
          id_sc_dtl_invoice: trd[0].id,
          termin_release_dtl_id: this.form.termin_release_dtl,
          termin_release_dtl_nm: trd[0].termin_description,
          termin_release_dtl_value: trd[0].value,
          id_sc_dtl_product: this.isEdit.item.id_sc_dtl_product,
          id: this.isEdit.status ? this.isEdit.item.id : nanoid(),
          note: this.form.note ? this.form.note : "",
          product_pn: this.form.pn ? this.form.pn :'-',
          product_nm: this.form.produk_name,
          qty: this.form.qty,
          unit: this.form.unit,
          unit_price: this.form.unit_price,
          total_price: 
            Number(this.form.qty) * Number(this.form.unit_price),
        };

        if (this.isEdit.status) {
          let indx = _.findIndex(this.detil_termin_list, (e) => { 
            return e.id == data.termin_release_dtl_id; }, 0);
          if (Number(this.detil_termin_list[indx].value)-Number(data.total_price)<0){
            this.displayMessageValue("error-other", "Amount value > Termin Detail Value!");
          }else{
            try {
              const source = this.sourcedata;

              //console.log(data);

              let index;
              if (data.id_sc_dtl_product == undefined) {
                console.warn("id dtl undefined");
                index = source.findIndex((item) => item.id === data.id);
              } else {
                console.warn("id undefined");
                index = source.findIndex(
                  (item) => item.id_sc_dtl_product === data.id_sc_dtl_product
                );
              }

              //console.log(source[index]);

              if (index >= 0) {
                source[index] = data;
                //console.log(source);
                this.sourcedata = source;
                this.detil_termin_list[indx].value = 
                Number(this.detil_termin_list[indx].value)-Number(data.total_price);
              }
            } catch (err) {
              return err;
            } finally {
              this.$refs.formInput.resetFields();
              this.handleCancel_2();
              Event.$emit("refreshProductDetail");
            }
          }
        } else {
          let indx = _.findIndex(this.detil_termin_list, (e) => { 
            return e.id == data.termin_release_dtl_id; }, 0);

          if (Number(this.detil_termin_list[indx].value)-Number(data.total_price)<-10000000){
            this.displayMessageValue("error-other", "Amount value > Termin Detail Value!");
          }else{
            this.$refs.formInput.resetFields();
            this.detil_termin_list[indx].value = 
              Number(this.detil_termin_list[indx].value)-Number(data.total_price);
            this.sourcedata.push(data);
          }
        }
      });
    },
    handleRef() {
      if (this.sourcedata.length <= 0) {
        this.displayMessage("form-moreData");
      } else if (this.isEdit.status){
        this.displayMessageValue("error-other", "Please finish editing this data!");
      } else {
        Event.$emit("emitChild", { detil_product: this.sourcedata });
      }
    },
    handleEdit(item) {
      let indx = _.findIndex(this.detil_termin_list, (e) => { 
                              return e.id == item.id_sc_dtl_invoice; }, 0);

      this.detil_termin_list[indx].value = 
        Number(this.detil_termin_list[indx].value)+Number(item.total_price);

      const data = {
        currency: item.currency,
        id_sc_dtl_product: item.id_sc_dtl_product,
        termin_release_dtl: item.id_sc_dtl_invoice,
        id: item.id,
        note: item.note,
        pn: item.product_pn,
        produk_name: item.product_nm,
        qty: item.qty,
        unit: item.unit,
        unit_price: item.unit_price,
      };
      this.form = JSON.parse(JSON.stringify(data));
      this.isEdit = {
        status: true,
        item: item,
      };
    },
    handleRemove(item) {
      const source = [...this.sourcedata];
      let index;
      if (this.mode == "Create") {
        index = source.findIndex((data) => data.id === item.id);
      } else {
        index = source.findIndex(
          (data) => data.id_sc_dtl_product === item.id_sc_dtl_product
        );
      }
      source.splice(index, 1);
      this.sourcedata = source;
    console.log(item)
      let indx = _.findIndex(this.detil_termin_list, (e) => { 
                      return e.id == item.termin_release_dtl_id; }, 0);
      this.detil_termin_list[indx].value = 
        Number(this.detil_termin_list[indx].value)+Number(item.total_price);

      Event.$emit("refreshProductDetail");
      this.displayMessage("success-del");
    },
    handleCancel_2() {
      this.isEdit = {
        status: false,
        item: {},
      };
      this.form = {
        qty:1
      };
    },
    handleCancel(){
      let indx = _.findIndex(this.detil_termin_list, (e) => { 
                      return e.id == this.isEdit.item.termin_release_dtl_id; }, 0);
      this.detil_termin_list[indx].value = 
        Number(this.detil_termin_list[indx].value)-Number(this.isEdit.item.total_price);
      this.handleCancel_2()
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
